import Link from "@/components/link";
import { Twitter, Youtube, FileText } from "lucide-react";

export function Footer() {
  return (
    <footer className="w-full border-t border-gray-200 bg-[#f8f7f4] py-3">
      <div className="container mx-auto px-4 flex justify-center items-center">
        <div className="flex space-x-6 md:space-x-8">
          <div className="relative group">
            <Link
              href="https://x.com/isaacbautistas"
              target="_blank"
              aria-label="Twitter"
              className="text-gray-400 hover:text-gray-800 transition-colors duration-200 flex items-center justify-center"
            >
              <Twitter size={20} strokeWidth={1.5} />
            </Link>
            <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
              Twitter
            </span>
          </div>

          <span className="text-gray-300">|</span>

          <div className="relative group">
            <Link
              href="https://www.youtube.com/@isaacbautista3721"
              target="_blank"
              aria-label="YouTube"
              className="text-gray-400 hover:text-gray-800 transition-colors duration-200 flex items-center justify-center"
            >
              <Youtube size={20} strokeWidth={1.5} />
            </Link>
            <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
              YouTube
            </span>
          </div>

          <span className="text-gray-300">|</span>

          <div className="relative group">
            <Link
              href="/cv"
              aria-label="Curriculum Vitae"
              className="text-gray-400 hover:text-gray-800 transition-colors duration-200 flex items-center justify-center"
            >
              <FileText size={20} strokeWidth={1.5} />
            </Link>
            <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
              Resume
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
